import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import axios from "axios";

function UpdateContact({ show, close, contactInfo, updateContactTab }) {
  const compte = localStorage.getItem("compte");
  const posteCol = localStorage.getItem("poste");
  const token = localStorage.getItem("AccessToken");
  const BackendURL = window.BackendURLCmk;
  // console.log("cfsfsdfsdf", contactInfo);
  // var kk = contactInfo.name;
  // console.log("kkkkkkk", kk);

  // const [nom, setNom] = useState(contactInfo.name);
  // console.log("nommmm", nom);

  // const [mobile, setMobile] = useState("ee");

  // const [tel, setTel] = useState("");

  // const [tel2, setTel2] = useState("");

  // const [tel3, setTel3] = useState("");

  // const [entreprise, setEntreprise] = useState(contactInfo.company);

  // const [mail, setMail] = useState("");
  useEffect(() => {
    if (document.getElementById("name_id") !== null) {
      document.getElementById("name_id").value = contactInfo.name;
      document.getElementById("company_id").value = contactInfo.company;
      document.getElementById("number_id").value = contactInfo.phoneNumber;
    }
  }, [contactInfo]);

  const handleOk = () => {
    var config1 = {
      headers: {
        Authorization: token,
      },
    };
    const result1 = axios
      .get(
        `https://${BackendURL}:4444/${
          window.switchAPI
        }/Api/WS/CRUDContactCarnetAdresseIPBXV3API?compte=${compte}&poste=${posteCol}&action=update&id=${
          contactInfo.id
        }&nom_prenom=${
          document.getElementById("name_id").value
        }&email&adresse=${
          document.getElementById("company_id").value
        }&tel_portable=${
          document.getElementById("number_id").value
        }&tel_fix&tel_3&tel_4=&tel_5=&commentaire=`,
        config1
        // config
      )
      .then((res) => {
        updateContactTab();
        close();
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });
  };

  return (
    <div>
      <Modal
        title="Ajouter contact"
        visible={show}
        onOk={handleOk}
        onCancel={close}
      >
        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Nom</label>
            <input
              id="name_id"
              type="text"
              // value={contactInfo.name}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Mobile</label>
            <input
              id="number_id"
              type="text"
              // value={mobile}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>
        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Entreprise</label>
            <input
              id="company_id"
              type="text"
              // value={entreprise}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Téléphone</label>
            <input
              type="text"
              // value={tel}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>
        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Téléphone 2</label>
            <input
              type="text"
              // value={tel2}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Téléphone 3</label>
            <input
              type="text"
              // value={tel3}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>
        <div className="flex justify-between	m-3">
          <div style={{ display: "grid" }}>
            <label>E-mail</label>
            <input
              type="text"
              // value={mail}
              onChange={(e) => console.log(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>{" "}
        </div>
      </Modal>
    </div>
  );
}

export default UpdateContact;
